module.exports = __webpack_public_path__ + "static/assets/4148bd4fa207fd584a884f31f7052bfc.svg";